export { default as InputLeftAddon } from './input-left-addon';
